module.exports = __webpack_public_path__ + "img/table.d411aa11.png";